export default "__VITE_ASSET__qqCB10Gy__"